import { render, staticRenderFns } from "./CompraDetalhesDadosBasicos.vue?vue&type=template&id=2403ea4b"
import script from "./CompraDetalhesDadosBasicos.vue?vue&type=script&lang=js"
export * from "./CompraDetalhesDadosBasicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports